import { defineComponent as _defineComponent } from 'vue'
import {useBlockStore} from "@/store/block.store";
import {computed} from "vue";
import {padStartZero} from "@/utils/number-formatter";


export default /*#__PURE__*/_defineComponent({
  __name: 'EstimatedUpgradeDate',
  props: {
    height: { type: Number, required: true }
  },
  setup(__props: any, { expose: __expose }) {
  __expose();

const props = __props;

const calculateDate = computed((): Date | null => {
  const secondsLeftLocal = (props.height - useBlockStore().getLatestBlock.height) * useBlockStore().averageBlockTime;
  if (secondsLeftLocal > 0) {
    let t = new Date();
    t.setSeconds(t.getSeconds() + secondsLeftLocal);
    return t;
  }
  return null;
});

function dateToString(date: Date): string {
  if (!date) {
    return "";
  }
  const day = date.getDate();
  const monthIndex = date.getMonth() + 1;
  const year = date.getFullYear();
  const minutes = date.getMinutes();
  const hours = date.getHours();
  const seconds = date.getSeconds();
  return '' + year + '.' + padStartZero(monthIndex, 2) + '.' + padStartZero(day, 2) + ' '
    + padStartZero(hours, 2) + ':' + padStartZero(minutes, 2) + ':' + padStartZero(seconds, 2);
}


const __returned__ = { props, calculateDate, dateToString }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

})